<app-loading *ngIf="viewModel.isLoading$ | async" [options]="viewModel?.loadingOpts$ | async"> </app-loading>

<div class="row padding-for-support-button header-padding">
  <div class="col-12">
    <div class="flex-container flex-row">
      <div class="flex-fill">
        <div class="bs-headline d-inline-flex">Displays</div>
        <app-location></app-location>
      </div>
      <div class="flex-container flex-row flex-align-center justify-content-end flex-wrap-content" [style.gap.rem]="1">
        <lib-button-neutral
          *ngIf="(viewModel.numberOfDisplays$ | async) > 0"
          [loading]="viewModel.reloadingDisplays$ | async"
          [iconSrc]="'assets/icons/dark/outline/refresh.svg'"
          (buttonClicked)="viewModel.openReloadDisplaysModal()">
          Reload Displays
        </lib-button-neutral>
        <lib-button-neutral
          (buttonClicked)="viewModel.reorderAllDisplays()"
          [iconSrc]="'assets/icons/dark/outline/collection.svg'"
          [hidden]="!(viewModel.showReorderingForAllDisplays$ | async)">
          Reorder Displays
        </lib-button-neutral>
        <lib-button-primary
          [iconSrc]="'assets/icons/light/outline/plus.svg'"
          (buttonClicked)="viewModel.openAddDisplayModal()">
          Add New Display
        </lib-button-primary>
      </div>
    </div>
    <hr class="mt-10px mb-10px" />

    <div [hidden]="viewModel?.isLoading$ | async" class="displays-body">
      <!--   No Displays Placeholder   -->
      <div [hidden]="viewModel.hideNoDisplayPlaceholder$ | async" class="no-results-container">
        <div class="no-results-title">No Displays Yet</div>
        <div class="no-results-body">
          It doesn't look like there are displays created at the
          {{ viewModel.currentLocationName$ | async }} location. Set up displays to pair your physical TVs with menus.
        </div>
        <lib-button-primary class="no-results-button" (buttonClicked)="viewModel.openAddDisplayModal()">
          Create a Display
        </lib-button-primary>
      </div>
      <!--   All Displays   -->
      <div *ngIf="viewModel.allDisplaysAreSameOrientation$ | async" class="row displays-container">
        <!-- Display Preview Cards -->
        <app-display-preview
          *ngFor="let disp of viewModel.allDisplays$ | async; let index = index; trackBy: viewModel.trackById"
          [ngClass]="{
            'col-6 col-lg-4 col-xl-3': disp.displaySize.orientation !== Types.Orientation.Landscape,
            'col-12 col-sm-12 col-md-6 col-xl-4': disp.displaySize.orientation === Types.Orientation.Landscape
          }"
          [displayableItem]="disp"
          [index]="index">
        </app-display-preview>
      </div>
      <!--   Landscape Displays   -->
      <div *ngIf="viewModel.showLandscapeDisplays$ | async" class="landscape-displays-container">
        <div class="displays-container-header">
          <div class="displays-container-title">Landscape Displays</div>
          <div class="displays-container-button">
            <lib-button-neutral
              (buttonClicked)="viewModel.reorderLandscapeDisplays()"
              [iconSrc]="'assets/icons/dark/outline/collection.svg'"
              [hidden]="(viewModel.landscapeDisplays$ | async)?.length < 2">
              Reorder Displays
            </lib-button-neutral>
          </div>
        </div>

        <div class="row displays-container bottom-border">
          <!-- Display Preview Cards -->
          <app-display-preview
            class="col-12 col-sm-12 col-md-6 col-xl-4"
            *ngFor="let disp of viewModel.landscapeDisplays$ | async; let index = index; trackBy: viewModel.trackById"
            [displayableItem]="disp"
            [index]="index">
          </app-display-preview>
        </div>
      </div>
      <!--   Portrait Displays   -->
      <div *ngIf="viewModel.showPortraitDisplays$ | async" class="portrait-displays-container">
        <div class="displays-container-header">
          <div class="displays-container-title">Portrait Displays</div>
          <div class="displays-container-button">
            <lib-button-neutral
              (buttonClicked)="viewModel.reorderPortraitDisplays()"
              [iconSrc]="'assets/icons/dark/outline/collection.svg'"
              [hidden]="(viewModel.portraitDisplays$ | async)?.length < 2">
              Reorder Displays
            </lib-button-neutral>
          </div>
        </div>

        <div class="row displays-container">
          <!-- Display Preview Cards -->
          <app-display-preview
            class="col-6 col-lg-4 col-xl-3"
            *ngFor="let disp of viewModel.portraitDisplays$ | async; let index = index; trackBy: viewModel.trackById"
            [displayableItem]="disp"
            [index]="index">
          </app-display-preview>
        </div>
      </div>
    </div>
  </div>
</div>
